export const AnalysisPharmacy = {
    path: '/analysis/pharmacy',
    name: 'analysis.pharmacy',
    component: () => import('@/views/Analysis/AnalysisPharmacy.vue')
}